import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Input,
} from '@angular/core'
import { appliedUiScale } from '@helios/utils'

/**
 * Credit from https://gist.github.com/markleusink/7af171d5f17e7dc9714e69965fdabab9
 */
@Directive({
  selector: '[hsDraggable]',
})
export class DraggableDirective implements AfterViewInit {
  private containerElement?: HTMLElement
  private handleElement?: HTMLElement
  private topStart = 0
  private leftStart = 0
  private isDraggable = false
  private scale = 1

  // Parent Class, the name has to be the same apparently
  @Input() hsDraggable: string | undefined = undefined

  constructor(public element: ElementRef) {}

  ngAfterViewInit() {
    let element: HTMLElement = this.element.nativeElement

    // This is the handle element, by default, the element is the handle element
    this.handleElement = this.element.nativeElement

    if (!this.handleElement) {
      // The handle element does not exist, so break
      return
    }

    //get the parent container element: that's the element we're going to move around
    if (this.hsDraggable) {
      // Crawl up the chain. document.parentNode doesn't exist so it'll break once it's at the top
      while (element.parentElement) {
        element = element.parentElement

        // Found the parent with that class
        if (element?.classList?.contains(this.hsDraggable)) {
          break
        }
      }
    }

    this.containerElement = element

    // Yes, apparently this needs to happen
    this.containerElement.style.position = 'relative'
    this.containerElement.classList.add('hs-draggable')
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    if (
      event.button === 2 ||
      (this.handleElement && event.target !== this.handleElement) ||
      // Container element doesn't exist, so break
      !this.containerElement
    ) {
      return // prevents right click drag
    }

    // change cursor to indicate that it's movable
    if (this.handleElement) this.handleElement.style.cursor = 'move'
    //enable dragging
    this.isDraggable = true

    this.scale = appliedUiScale()

    // clientY/clientX into the space style.top/left are written in — see
    // appliedUiScale. Left mixed, the modal drifts behind the cursor.
    this.topStart =
      event.clientY / this.scale -
      Number(this.containerElement.style.top.replace('px', ''))
    this.leftStart =
      event.clientX / this.scale -
      Number(this.containerElement.style.left.replace('px', ''))
    event.preventDefault()
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp() {
    this.isDraggable = false
    // change cursor to indicate that it's movable
    if (this.handleElement) this.handleElement.style.cursor = 'default'
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    // Container element should exist
    if (this.isDraggable && this.containerElement) {
      //on moving the mouse, reposition the modal
      this.containerElement.style.top =
        event.clientY / this.scale - this.topStart + 'px'
      this.containerElement.style.left =
        event.clientX / this.scale - this.leftStart + 'px'
    }
  }

  @HostListener('document:mouseleave', ['$event'])
  onMouseLeave() {
    this.isDraggable = false
  }
}
